'use client'

import { trackPodcastEpisodePlayed } from '@/lib/analytics'
import { useState } from 'react'
import { Play } from '@/components/ui/icons'

// Our own poster and play button instead of YouTube's chrome; the player loads on click.
export function EpisodePlayer({ id, n, title }: { id: string; n: number; title: string }) {
  const [playing, setPlaying] = useState(false)
  if (playing) {
    return (
      <iframe
        src={`https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
        className="absolute inset-0 h-full w-full"
      />
    )
  }
  return (
    <button
      type="button"
      onClick={() => {
        setPlaying(true)
        trackPodcastEpisodePlayed({ episode: n, videoId: id })
      }}
      className="group absolute inset-0"
      aria-label={`Play ${title}`}
    >
      {/* eslint-disable-next-line @next/next/no-img-element -- YouTube poster */}
      <img
        src={`https://i.ytimg.com/vi/${id}/maxresdefault.jpg`}
        alt=""
        className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
      />
      <span className="absolute inset-0 bg-black/20 transition-colors group-hover:bg-black/10" />
      <span className="absolute bottom-5 start-5 flex h-14 w-14 items-center justify-center rounded-full bg-white text-black shadow-lg transition-transform duration-200 group-hover:scale-105">
        <Play className="ms-0.5 h-5 w-5 fill-current" />
      </span>
    </button>
  )
}
